export const personFlags = {
  onboarding: {
    setup: 'setup', // new onboarding flow
  },
  search: {
    is_assisted_search_enabled: 'is_assisted_search_enabled',
  },
};
